import { render, staticRenderFns } from "./onlineStatusCom.vue?vue&type=template&id=221cb0c2"
import script from "./onlineStatusCom.vue?vue&type=script&lang=js"
export * from "./onlineStatusCom.vue?vue&type=script&lang=js"
import style0 from "./onlineStatusCom.vue?vue&type=style&index=0&id=221cb0c2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221cb0c2')) {
      api.createRecord('221cb0c2', component.options)
    } else {
      api.reload('221cb0c2', component.options)
    }
    module.hot.accept("./onlineStatusCom.vue?vue&type=template&id=221cb0c2", function () {
      api.rerender('221cb0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/onlineStatusCom.vue"
export default component.exports